import "./App.css";
import Header from "components/core/Header/Header";
import Auth from "components/core/Auth/Auth";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "components/core/Route/PrivateRoute";
import Container from "components/core/Container/Container";
import Login from "components/core/Login/Login";
import HomePage from "components/core/HomePage/HomePage";
import PendingPo from "components/core/PO/PendingPo";
import PoDetails from "components/core/PO/PoDetails";
import PendingGrn from "components/core/GRN/PendingGrn";
import GrnDetails from "components/core/GRN/GrnDetails";
import AllPoView from "components/core/PO/AllPoView";
import Invoice from "components/core/GRN/Invoice";
import CreditNote from "components/core/GRN/CreditNote";
import Tnc from "components/core/Login/Tnc"
import AllDDPoView from "./components/core/PO/AllDDPoView";
import DDPoDetails from "./components/core/PO/DDPoDetails";
import DDPoInvoiceForm from "./components/core/PO/DDPoInvoiceForm";
import ToastContainer from "sushiweb/ToastContainer";
import DDPodForm from "./components/core/PO/DDPodForm";
import DDPodFormV2 from "./components/core/PO/DDPodFormV2";
import BOView from "./components/core/PO/BOView";
import ReuploadInvoice from "components/core/PO/ReuploadInvoice";
import ServicePoView from "./components/core/PO/ServicePoView";
import AllServicePOsView from "./components/core/PO/AllServicePOsView";
import Profile from "components/core/Profile/Profile";
import DeleteAccount from "components/core/DeleteAccount/DeleteAccount";
import DeleteAccountOtp from "components/core/DeleteAccount/DeleteAccountOtp";
import PlanShipment from "components/core/PlanShipment/PlanShipment";
import UploadDocuments from "./components/core/PO/UploadDocuments";
import GenerateEwb from "./components/core/PO/GenerateEwb";
import UploadSupportingDocs from "./components/core/PO/UploadSupportingDocs";
import DownloadLabels from "./components/core/EmbeddedUpc/DownloadLabels";
import TrackPageLoad from "components/core/Route/TrackPageLoad";
import TrackClick from "components/core/Route/TrackClick";
import BidsFilterPage from "./components/core/Bids/BidsFilterPage";
import BidsList from "./components/core/Bids/BidsList";
import BidDetails from "./components/core/Bids/BidDetails";
import BidsFAQ from "./components/core/Bids/BidsFAQ";
import BidConfirmation from "./components/core/Bids/BidConfirmation";
import BidsDesktopNotice from "./components/core/Bids/BidsDesktopNotice";
import OnboardingForm from "components/core/Onboarding/OnboardingForm";
import PaymentsPlaceholder from "components/core/Onboarding/PaymentsPlaceholder";
import ManageUsers from "components/core/ManageUsers/ManageUsers";
import AddUser from "components/core/ManageUsers/AddUser";
import AddUserSuccess from "components/core/ManageUsers/AddUserSuccess";

function App() {
  return (
    <ToastContainer>
      <div className="App">
        {/* Routes */}
        <Router>
          <TrackPageLoad />
          <TrackClick />
          <Routes>
            <Route
              path={"/"}
              element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route path={"login"} element={<Login />} />
            <Route path={"onboarding/form"} element={<OnboardingForm />} />
            <Route path={"payments"} element={<PaymentsPlaceholder />} />
            <Route
              path={"po/pending"}
              element={
                <PrivateRoute>
                  <PendingPo />
                </PrivateRoute>
              }
            />
            <Route
              path={"/tnc/:status"}
              element={
                <PrivateRoute>
                  <Tnc />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/details/:source/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <PoDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/details/:source/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <DDPoDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/invoice/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <DDPoInvoiceForm />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/pod/:purchaseOrderId/:orderId/:goTo"}
              element={
                <PrivateRoute>
                  <DDPodForm />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/pod/v2/:purchaseOrderId/:orderId"}
              element={
                <PrivateRoute>
                  <DDPodFormV2 />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/pending"}
              element={
                <PrivateRoute>
                  <PendingGrn />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/details/:source/:purchaseOrderId/:grnId"}
              element={
                <PrivateRoute>
                  <GrnDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/invoice/:source/:purchaseOrderId/:grnId"}
              element={
                <PrivateRoute>
                  <Invoice />
                </PrivateRoute>
              }
            />
            {/* CreditNote */}
            <Route
              path={"grn/creditNote/:grnId"}
              element={
                <PrivateRoute>
                  <CreditNote />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/all"}
              element={
                <PrivateRoute>
                  <AllPoView />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/all"}
              element={
                <PrivateRoute>
                  <AllDDPoView />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/:purchaseOrderId/buyer_orders"}
              element={
                <PrivateRoute>
                  <BOView />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/service/:type"}
              element={
                <PrivateRoute>
                  <ServicePoView />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/service/all"}
              element={
                <PrivateRoute>
                  <AllServicePOsView />
                </PrivateRoute>
              }
            />
            <Route
              path={"upload-documents/:purchaseOrderNumber"}
              element={
                <PrivateRoute>
                  <UploadDocuments />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/generateEwb/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <GenerateEwb />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/uploadDocs/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <UploadSupportingDocs />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn-document-update/:grnNumber/:referenceNumber"}

              element={
                <PrivateRoute>
                  <ReuploadInvoice />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/all"}
              element={
                <PrivateRoute>
                  <BidsFilterPage />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/faq"}
              element={
                <PrivateRoute>
                  <BidsFAQ />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/confirm"}
              element={
                <PrivateRoute>
                  <BidsDesktopNotice title="Bid submitted">
                    <BidConfirmation />
                  </BidsDesktopNotice>
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/details/:bidId"}
              element={
                <PrivateRoute>
                  <BidsDesktopNotice title="Bid details">
                    <BidDetails />
                  </BidsDesktopNotice>
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/list/:status"}
              element={
                <PrivateRoute>
                  <BidsDesktopNotice title="All bids">
                    <BidsList />
                  </BidsDesktopNotice>
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/:status"}
              element={
                <PrivateRoute>
                  <BidsDesktopNotice title="Bids">
                    <BidsList />
                  </BidsDesktopNotice>
                </PrivateRoute>
              }
            />
            <Route
              path={"profile"}
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users"}
              element={
                <PrivateRoute>
                  <ManageUsers />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users/add"}
              element={
                <PrivateRoute>
                  <AddUser />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users/add/success"}
              element={
                <PrivateRoute>
                  <AddUserSuccess />
                </PrivateRoute>
              }
            />
            <Route
              path={"delete-account"}
              element={
                <PrivateRoute>
                  <DeleteAccount />
                </PrivateRoute>
              }
            />
            <Route
              path={"download-labels"}
              element={
                <PrivateRoute>
                  <DownloadLabels />
                </PrivateRoute>
              }
            />
            <Route
              path={"delete-account/verify"}
              element={
                <PrivateRoute>
                  <DeleteAccountOtp />
                </PrivateRoute>
              }
            />
            <Route
              path={"plan-shipment"}
              element={
                <PrivateRoute>
                  <PlanShipment />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </div>
    </ToastContainer>
  );
}

export default App;
